// extracted by mini-css-extract-plugin
export default {"cronometro":"Cronometro_cronometro__qQpWB","cronometro__icone":"Cronometro_cronometro__icone__oMMp0","cronometro__icone--ativo":"Cronometro_cronometro__icone--ativo__zmyqg"};